export default __webpack_public_path__ + "227f92b070bf9d8ad498909b21c4726d.svg";